import './bootstrap';
import '../css/app.css';
import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
//import { Ziggy } from './ziggy';
import Vapor from 'laravel-vapor'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import ApexChart from './Components/ApexChart.vue';
import Vidle from '@/Package/Vidle'
import store from "./store";

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Home Care by AIRISPS';
Vapor.withBaseAssetUrl(import.meta.env.VITE_VAPOR_ASSET_URL);
window.Vapor = Vapor


createInertiaApp({
    title: (title) => `Home Care by AIRISPS`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(VueSweetalert2)
            .component('apexchart', ApexChart)
            .use(Vapor)
            .use(Vidle)
            .use(store)
            .mixin({
                methods: { asset: window.Vapor.asset }
            })
            .directive('focus', {
                mounted(el) {
                  el.focus()
                }
            })
            .mount(el);

    },
    progress: {
        color: '#4B5563',
    },
});
